const UUID = /([0-9a-f]{8})-?([0-9a-f]{4})-?([0-9a-f]{4})-?([0-9a-f]{4})-?([0-9a-f]{12})/i;
export function elfsightShareLink(input) {
    const text = (input !== null && input !== void 0 ? input : "").trim();
    if (!text)
        return null;
    const share = text.match(/([0-9a-f]{32})\.elf\.site/i);
    if (share)
        return `https://${share[1].toLowerCase()}.elf.site`;
    const looksElfsight = /elfsight-app-/i.test(text) ||
        /elfsight\.com/i.test(text) ||
        (UUID.test(text.replace(/\s/g, "")) &&
            text.replace(/[\s-]/g, "").length === 32);
    if (!looksElfsight)
        return null;
    const m = text.match(UUID);
    if (!m)
        return null;
    return `https://${m.slice(1, 6).join("").toLowerCase()}.elf.site`;
}
export const ELFSIGHT_VIEW_NOTE = "Elfsight counts a view every time this slide appears on a screen. The free plan (200 views a month) runs out within a day on a lobby screen, and Elfsight then switches the feed off until next month. Use a paid Elfsight plan, or keep this slide on screen for long stretches (a block in the day plan) rather than in a fast loop.";
